import React from "react";
import { useShoppingCart } from "../../../context/CartContext.tsx/ShoppingCartContext";

interface medicalPowersProp {
  left_boxes?: number | any;
  right_boxes?: number | any;
  left_sph?: string;
  left_cyl?: string;
  left_axis?: string;
  right_sph?: string;
  right_cyl?: string;
  right_axis?: string;
  price?: string | any;
  temp_cart_id?: number | any;
  cart_id: number | any;
  right?: boolean | any;
  left?: boolean | any;
  ap_left?: string | any;
  ap_right?: string | any;
  is_apLeft?: boolean | any;
  is_apRight?: boolean | any;
  power_type?:string;
  compare_at_price?:string | any;
}

export const MedicalPowers = (props: medicalPowersProp) => {
  const { updateCartItem } = useShoppingCart();

  let quantity = 0;
  if (
    props.left_boxes === undefined ||
     props.left_boxes === null
  ) {
    quantity = parseInt(props.right_boxes);
  } else if (
   props.right_boxes === undefined ||
   props.right_boxes === null
  ) {
    quantity = parseInt(props.left_boxes);
  } else {
    quantity = parseInt(props.left_boxes) + parseInt(props.right_boxes);
  }

  // console.log(
  //   parseInt(props.left_boxes),
  //   props.left,
  //   parseInt(props.right_boxes),
  //   props.right,
  //   props.temp_cart_id,
  //   console.log(typeof quantity,'dty qty')
  // );

  const increaseQuantityLeft = {
    cart_id: props.cart_id,
    cart_item_id: props.temp_cart_id,
    quantity: quantity + 1,
    prescription: {
      powerType: "CONTACT_LENS",
      ...(props.left === true && {
        left: {
          boxes: parseInt(props.left_boxes) + 1,
          sph: props.left_sph,
          cyl: props.left_cyl,
          axis: props.left_axis,
          ...(props.ap_left !== null && { ap: props.ap_left }),
        },
      }),
      ...(props.right === true && {
        right: {
          boxes: parseInt(props.right_boxes),
          sph: props.right_sph,
          cyl: props.right_cyl,
          axis: props.right_axis,
          ...(props.ap_right !== null && { ap: props.ap_right }),
        },
      }),
    },
  };
  

  const decreaseQuantityLeft = {
    cart_id: props.cart_id,
    cart_item_id: props.temp_cart_id,
    quantity: quantity - 1,
    prescription: {
      powerType: "CONTACT_LENS",
      ...(props.left === true && {
        left: {
          boxes: parseInt(props.left_boxes) - 1,
          sph: props.left_sph,
          cyl: props.left_cyl,
          axis: props.left_axis,
          ...(props.ap_left !== null && { ap: props.ap_left }),
        },
      }),
      ...(props.right === true && {
        right: {
          boxes: parseInt(props.right_boxes),
          sph: props.right_sph,
          cyl: props.right_cyl,
          axis: props.right_axis,
          ...(props.ap_right !== null && { ap: props.ap_right }),
        },
      }),
    },
  };

  const increaseQuantityRight = {
    cart_id: props.cart_id,
    cart_item_id: props.temp_cart_id,
    quantity: quantity + 1,
    prescription: {
      powerType: "CONTACT_LENS",
      ...(props.left === true && {
        left: {
          boxes: parseInt(props.left_boxes),
          sph: props.left_sph,
          cyl: props.left_cyl,
          axis: props.left_axis,
          ...(props.ap_left !== null && { ap: props.ap_left }),
        },
      }),
      ...(props.right === true && {
        right: {
          boxes: parseInt(props.right_boxes) + 1,
          sph: props.right_sph,
          cyl: props.right_cyl,
          axis: props.right_axis,
          ...(props.ap_right !== null && { ap: props.ap_right }),
        },
      }),
    },
  };

  const decreaseQuantityRight = {
    cart_id: props.cart_id,
    cart_item_id: props.temp_cart_id,
    quantity: quantity - 1,
    prescription: {
      powerType: "CONTACT_LENS",
      ...(props.left === true && {
        left: {
          boxes: parseInt(props.left_boxes),
          sph: props.left_sph,
          cyl: props.left_cyl,
          axis: props.left_axis,
          ...(props.ap_left !== null && { ap: props.ap_left }),
        },
      }),
      ...(props.right === true && {
        right: {
          boxes: parseInt(props.right_boxes) - 1,
          sph: props.right_sph,
          cyl: props.right_cyl,
          axis: props.right_axis,
          ...(props.ap_right !== null && { ap: props.ap_right }),
        },
      }),
    },
  };

  return (
    <>
      <div className="powerWrappers">
        {props.left_sph && (
          <div className="leftPowerWrapper">
            <div className="quantityItem">
              <div className="eyeSpecs">
                <span className="eyeHeading">Left Eye : </span>
                <span className="quantityCount">
                  <button
                    onClick={
                      parseInt(props.left_boxes) > 1
                        ? () => updateCartItem(decreaseQuantityLeft)
                        : undefined
                    }
                  >
                   -
                  </button>
                  {parseInt(props.left_boxes)}
                  <button onClick={() => updateCartItem(increaseQuantityLeft)}>
                    +
                  </button>
                </span>
              </div>
              <div className="itemPrice">
              {/* <span className="itemPriceCompare">Rs. 300 </span> */}
              <span className="itemPriceCompare">Rs. {props.compare_at_price * parseInt(props.left_boxes)} </span>
              <span className="itemPriceSelling">Rs. {props.price * parseInt(props.left_boxes)}</span>
              </div>
            </div>

            <div className="leftPowers powersData">
              <span className="powersHeading">SPH:</span>{" "}
              <span className="powers">{props.left_sph.split('/')[0].trim()}</span>

              {props.ap_left !== "" && props.is_apLeft === true && (
                <>
                 <span className="separator"></span>
                  <span className="powersHeading">AP:</span>
                  <span className="powers">{props.ap_left.split('/')[0].trim()}</span>
                </>
              )}
            </div>
          </div>
        )}

        {props.right_sph && (
          <div className="rightPowerWrapper">
            <div className="quantityItem">
              <div className="eyeSpecs">
                <span className="eyeHeading">Right Eye : </span>
                <span className="quantityCount">
                  <button
                    onClick={
                      parseInt(props.right_boxes) > 1
                        ? () => updateCartItem(decreaseQuantityRight)
                        : undefined
                    }
                  >
                    -
                  </button>
                  {parseInt(props.right_boxes)}
                  <button onClick={() => updateCartItem(increaseQuantityRight)}>
                    +
                  </button>
                </span>
              </div>
              <div className="itemPrice">
              {/* <span className="itemPriceCompare">Rs. 300 </span> */}
              <span className="itemPriceCompare">Rs. {props.compare_at_price * parseInt(props.right_boxes)} </span>
              <span className="itemPriceSelling">Rs. {props.price * parseInt(props.right_boxes)}</span>
              </div>
            </div>
            <div className="rightPowers powersData">
              <span className="powersHeading">SPH:</span>{" "}
              <span className="powers">{props.right_sph.split('/')[0].trim()}</span>
              {props.ap_right !== "" && props.is_apRight === true && (
                <>
                 <span className="separator"></span>
                  <span className="powersHeading">AP:</span>{" "}
                  <span className="powers">{props.ap_right.split('/')[0].trim()}</span>
                </>
              )}
            </div>
          </div>
        )}
      </div>

      {/* <div className="heading headingBold">
                <span>Eye</span>
                <span>Boxes</span>
                <span>SPH</span>
            </div>
            <div className="heading">
                <span>Left</span>
                <span className="quantityCount"><button>-</button>{props.boxes}<button>+</button></span>
                <span>{props.sph}</span>
            </div>
            <div className="heading">
                <span>Right</span>
                <span className="quantityCount"><button>-</button>{props.boxes}<button>+</button></span>
                <span>{props.sph}</span>
            </div> */}
    </>
  );
};
